// Selection helpers shared by ribbon, dialogs and context menus
export const isTextType = (o) => !!o && (o.type === 'textbox' || o.type === 'text');
export const isShapeType = (o) => !!o && o.type === 'shape';
export const isImageType = (o) => !!o && o.type === 'image';

/**
 * Returns 'none' | 'text' | 'shape' | 'image' | 'table' | 'group' | 'mixed'
 */
export const getSelectionKind = (objects) => {
  if (!objects || objects.length === 0) return 'none';
  const kinds = new Set(objects.map((o) => (isTextType(o) ? 'text' : o.type)));
  if (kinds.size === 1) return [...kinds][0];
  return 'mixed';
};

export const CONTEXT_TAB_FOR_KIND = { text: 'text-box', shape: 'shape-format', image: 'picture-format', table: 'table-design' };
export const CONTEXT_TABS = new Set(Object.values(CONTEXT_TAB_FOR_KIND));

export const contextTabForObject = (o) => (o ? CONTEXT_TAB_FOR_KIND[isTextType(o) ? 'text' : o.type] || null : null);

/** A shape that carries text (or is having text typed into it) counts as a text target for formatting commands. */
export const isShapeWithText = (o, editingId = null) => !!o && o.type === 'shape' && ((!!editingId && editingId === o.id) || !!(o.properties?.html ? o.properties.html.replace(/<[^>]+>|&nbsp;|\s/g, '') : (o.properties?.text || '').trim()));

/**
 * Contextual ribbon tabs for a selection. Shapes with text get both Shape Format and Text Box (Publisher shows
 * Drawing Tools and Text Box Tools side by side).
 */
export const contextTabsForSelection = (objects, editingId = null) => {
  const kind = getSelectionKind(objects);
  const tabs = CONTEXT_TAB_FOR_KIND[kind] ? [CONTEXT_TAB_FOR_KIND[kind]] : [];
  if (kind === 'shape' && objects.some((o) => isShapeWithText(o, editingId))) tabs.push('text-box');
  return tabs;
};

/** Common property getter across a set of objects: returns the value if all equal, otherwise undefined */
export const commonProp = (objects, key, fallback) => {
  if (!objects.length) return fallback;
  const first = objects[0].properties?.[key];
  return objects.every((o) => (o.properties?.[key] ?? undefined) === first) ? (first ?? fallback) : fallback;
};

export const toggleToken = (str, token) => {
  const set = new Set(String(str || 'none').split(/\s+/).filter((t) => t && t !== 'none'));
  if (set.has(token)) set.delete(token); else set.add(token);
  return set.size ? [...set].join(' ') : 'none';
};
